<template>
  <div class="market-statistics">
    <div class="tuolele-main-box">
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">选择店铺</span>
          <el-select v-model="filterObj.shop_id">
            <el-option label="全部" value="0" />
            <el-option
              v-for="item in shopList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-input fn-clear">
          <span class="fn-left">选择时间</span>
          <el-date-picker
            v-model="filterObj.begin_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
          />
          <i>至</i>
          <el-date-picker
            v-model="filterObj.end_time"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
          />
          <b
            class="default-btn"
            :class="{ active: filterObj.search_calendar == '1' }"
            @click="selectDataForAccount"
          >
            只看工作日
          </b>
          <el-button type="primary" @click="getDataForAccount">查询</el-button>
        </div>
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :data="dataInfo" border stripe max-height="800px">
        <el-table-column
          type="index"
          width="200"
          label="排名"
          align="center"
        />
        <el-table-column
          prop="name"
          label="姓名"
          align="center"
        />
        <el-table-column
          prop="data.B1"
          label="上门量"
          sortable
          align="center"
        />
        <el-table-column
          prop="data.C4"
          label="新签"
          sortable
          align="center"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import Tool from '@/assets/js/tool.js'
export default {
  name: 'SalesmanStatistics',
  data() {
    return {
      filterObj: {
        begin_time: '',
        end_time: '',
        shop_id: '0',
        search_calendar: '',
        key: 'B1,C4'
      },
      shopList: [],
      dataInfo: [],
      init: true
    }
  },
  mounted() {
    this.filterObj.begin_time = Tool.formatTime(
      new Date() - 86400 * 1000 * 30,
      'date'
    )
    this.filterObj.end_time = Tool.formatTime(new Date(), 'date')
    this.getMyShopList()
  },
  methods: {
    getMyShopList() {
      this.$http.getMyShopList().then(res => {
        this.shopList = res.data
      })
      this.getDataForAccount()
    },
    getDataForAccount() {
      this.$http.getDataForAccount(this.filterObj).then(res => {
        if (res.code == 200) {
          this.dataInfo = res.data.account_data
          this.dataInfo.forEach(e => {
            e.data.B1 = e.data.B1 ? parseInt(e.data.B1) : 0
            e.data.C4 = e.data.C4 ? parseInt(e.data.C4) : 0
          })
        }
      })
    },
    updateShop(val) {
      this.filterObj.shop_id = val.join(',')
      if (this.init) {
        this.init = false
        this.getDataForAccount()
      }
    },
    selectDataForAccount() {
      this.filterObj.search_calendar =
        this.filterObj.search_calendar == '1' ? '' : '1'
    }
  }
}
</script>
<style lang="scss" scoped>
.market-statistics {
  .form-row {
    .form-input {
      .el-button {
        width: 90px;
        height: 40px;
        margin-left: 20px;
      }
      > i {
        font-style: normal;
        margin: 0 10px;
      }
    }
  }
  .search-box {
    margin-top: 20px;
  }
  .el-form-item {
    display: block;
    .el-input {
      width: 150px;
      margin-left: 30px;
      margin-right: 20px;
    }
    .el-form-item__content {
      width: 90%;
    }
  }
  .default-btn {
    display: inline-block;
    width: 150px;
    height: 40px;
    margin-left: 20px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-weight: normal;
    color: #999;
    border-radius: 6px;
    border: solid 1px #dcdfe6;
    &.active {
      border: solid 1px #4c84ff;
      color: #4c84ff;
    }
  }
  .el-table td {
    div {
      text-align: center !important;
    }
    .cell {
      text-align: center !important;
    }
  }
}
</style>
